/**
 * Created by Administrator on 2017/10/26.
 */
import {Component} from "@angular/core";
import {HttpService} from "../service/http-service";
import {StroageService} from "../service/stroage";
import {Router} from "@angular/router";
@Component({
  templateUrl:"./index.html"
})

export class Login{
  constructor(private httpService:HttpService,private router:Router,private stroage:StroageService){}
  //初始化
  private tip:string='';
  private user={
    account:'',
    pwd:''
  }
  //登录函数
  private login(account:string,pwd:string):void{
    if(account!='' && pwd!=''){
      this.httpService.login({username:account,password:pwd})
        .then(res=>{
          let data=res;
          if(data.status.code==0 || data.status.code=='0'){
            let roleArray = data.data.roles;
            let roles = [];
            for (let i=0;i<roleArray.length;i++){
              roles.push(roleArray[i].name);
            }
            this.stroage.setStroage('token',data.data.token);
            this.stroage.setStroage('roles',roles.join(','));
            this.stroage.setStroage('username',data.data.username);
            this.stroage.setStroage('name',data.data.name);
            this.router.navigate(['/index']);
          }else {
            //alertify.success(data.status.message);
            this.tip = data.status.message;
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/login/login.component.ts